import { USUARIO_REMOVE, USUARIO_CREATE } from "../actions/cliente";
import {
  USUARIO_LOAD,
  USUARIO_LOAD_ESTRUTURA,
  USUARIO_DISABLE,
  USUARIO_ENABLE,
  USUARIO_UPDATE,
  USUARIO_NEW,
  USUARIO_UPDATE_INTEGRATIONS,
  USUARIO_LOAD_PROFILE,
  USUARIO_UPDATE_PASSWORD,
  USUARIO_UPDATE_NAME,
  USUARIO_UPDATE_PERMISSION,
  USUARIO_LOAD_ALL,
  USUARIO_APPROVE,
  LOAD_USUARIO_PERMISSOES,
  USUARIO_CLIENTE_LOAD,
  USUARIO_CLIENTE_UPDATE
} from "../actions/usuario";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const resolveUsuarioContext = (getters, payload = {}) => ({
  idempresa: payload.idempresa || payload.empresa || getters.getEmpresaId,
  idfornecedor: payload.idfornecedor || getters.getFornecedorId
});

const state = {
  active: null
};

const getters = {};

const actions = {
  [USUARIO_REMOVE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.usuario
        .removerVinculoUsuario(
          payload.idusuario,
          payload.idfornecedor,
          payload.idcadastroextracliente
        )
        .then(() => resolve())
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_CREATE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.usuario
        .criarVinculoUsuario(
          payload.email,
          payload.idcadastroextracliente,
          payload.idfornecedor,
          payload.permissoes || [],
          payload.categoriasrestricao || []
        )
        .then(() => resolve())
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_UPDATE_PERMISSION]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.usuario
        .atualizarPermissaoNavegacao(
          getters.getFornecedorId,
          payload.idusuario,
          payload
        )
        .then(() => resolve())
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_DISABLE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.usuario
        .desativarUsuario(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_ENABLE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.usuario
        .reativarUsuario(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_UPDATE]: ({ dispatch, getters }, payload) => {
    const { idempresa, idfornecedor } = resolveUsuarioContext(getters, payload);
    return new Promise((resolve, reject) => {
      Api.v4.usuario
        .atualizarUsuarioCompleto(
          payload.idusuario,
          idempresa,
          idfornecedor,
          payload
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_NEW]: ({ dispatch, getters }, payload) => {
    const { idfornecedor } = resolveUsuarioContext(getters, payload);
    return new Promise((resolve, reject) => {
      Api.v4.usuario
        .criarUsuarioCompleto(idfornecedor, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_LOAD]: ({ dispatch, getters }, payload) => {
    const idusuario = typeof payload === "object" ? payload.idusuario : payload;
    const { idempresa, idfornecedor } = resolveUsuarioContext(
      getters,
      typeof payload === "object" ? payload : {}
    );
    return new Promise((resolve, reject) => {
      Api.v4.usuario
        .obterUsuario(idusuario, idempresa, idfornecedor)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_LOAD_ESTRUTURA]: ({ dispatch, getters }, payload = {}) => {
    const { idempresa, idfornecedor } = resolveUsuarioContext(getters, payload);
    return new Promise((resolve, reject) => {
      Api.v4.usuario
        .obterEstruturaFormulario(idempresa, idfornecedor)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_UPDATE_INTEGRATIONS]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.usuario
        .atualizarIntegracoes(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_UPDATE_PASSWORD]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.usuario
        .alterarSenhaMeuUsuario(
          getters.getFornecedorId,
          payload.oldPass,
          payload.newPass,
          getters.getUsuarioId
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_UPDATE_NAME]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.usuario
        .alterarNomeUsuario(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_LOAD_PROFILE]: ({ dispatch }) => {
    return new Promise((resolve, reject) => {
      Api.v2.usuario
        .getPerfil()
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_LOAD_ALL]: ({ dispatch, getters }) => {
    return new Promise((resolve, reject) => {
      Api.v2.usuario
        .getUsuarios(getters.getEmpresaId)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_APPROVE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.usuario
        .approveUserTests(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [LOAD_USUARIO_PERMISSOES]: ({ dispatch, getters }) => {
    return new Promise((resolve, reject) => {
      Api.v1.usuario
        .listarUsuarioPermissoes(getters.getFornecedorId)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_CLIENTE_LOAD]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.usuario
        .buscarUsuarioCliente(payload.idusuario, payload.idcadastroextracliente)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [USUARIO_CLIENTE_UPDATE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.usuario
        .atualizarUsuarioCliente(
          payload.idusuario,
          payload.idcadastroextracliente,
          payload.permissoes || [],
          payload.categoriasrestricao || []
        )
        .then(() => resolve())
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};
const mutations = {};
export default {
  state,
  getters,
  actions,
  mutations
};
